<template>
  <div
    id="app"
    :class="[
    $store.state.app.view_pattern + '_pattern',
    $store.state.app.language == 'zh-cn' ? 'chinese_station' : 'foreign_station',
    $store.state.app.road_type == 1 ? 'foreign_trade_station' : 'domestic_station',
    isFullPage?'is-full-page':'',
    'web_language_wm_' + $store.state.app.web_language_wm
    ]"
    :style="{'--theme_color': theme_color}"
  >

    <router-view :key="$route.fullPath"/>
    <!--颜色选择器相关-->
    <template v-if="$store.state.color.isShow">
      <my_color_picker></my_color_picker>
      <div
        class="my_color_picker_mongolia"
        @click="()=>{$store.commit('color/isShow_change',false)}"
      ></div>
    </template>

    <!--预览部分-->
    <preview v-if="$store.state.preview.isShow"></preview>
  </div>
</template>

<script>
import i18n from './language/index'

import preview from "@/view/preview";
import Cookies from "js-cookie";
import store from "./vuex/store";
import {getLangs,siteConfig} from './api/app'
import {mapMutations} from 'vuex'

export default {
  name: "App",
  methods: {
    async getSiteConfig() {
      let res = await siteConfig()
      if( res.code == 200 && res.data){
        if (typeof res.data.googlePrivacy !== 'undefined') {
          const googlePrivacy = Number(res.data.googlePrivacy)
          this.$store.commit('app/set_isPrivacyPolicyShow', googlePrivacy == 0 ? false : true)
        }
        if (typeof res.data.tag_setting !== 'undefined') {
          const isShow = Number(res.data.tag_setting.isShow)
          this.$store.commit('app/SET_isTagShow', isShow == 0 ? false : true)
        }

      }
    },
    init() {
      let script = document.getElementById('ipScript');
      // if(this.map) return;
      // this.isBodyLoading = true;
      if (!script) {
        script = document.createElement('script');
        script.id = 'ipScript';
        script.src = 'http://pv.sohu.com/cityjson?ie=utf-8';
        document.body.append(script);
      }
    },
    set_view_pattern() {
      const view_pattern = Cookies.get("view_pattern_wm");
      if (view_pattern) {
        this.$store.commit("app/Change_pattern", view_pattern);
      } else {
        this.$store.commit("app/Change_pattern", "pc");
      }
    },
    ctrl_s(event) {
      if (store.state.app.pageDataLoading) {
        event.preventDefault()
        return;
      }
      if (event.ctrlKey == true && event.keyCode == 83) {
        console.log('ctrl_s')
        event.preventDefault()
        this.templet.implement_save();
      }
    },
    ctrl_z(event) {
      if (store.state.app.pageDataLoading) {
        return;
      }
      if (event.ctrlKey == true && event.keyCode == 90) {
        console.log('ctrl_z')
        this.templet.implement_Revoke();
      }
    },
    ctrl_y(event) {
      if (store.state.app.pageDataLoading) {
        return;
      }
      if (event.ctrlKey == true && event.keyCode == 89) {
        console.log('ctrl_y')
        this.templet.implement_Recovery();
      }
    },
    async getLangs(){
      let res = await getLangs()
      if( res.code == 200 && Object.prototype.toString.call(res.data) == '[object Object]' ){
        this.set_lang(res.data)
      }
    },
    ...mapMutations('language',['set_lang'])
  },
  components: {
    preview
  },
  computed: {
    theme_color() {
      return this.$store.state.myRender.common.theme_color;
    },
    isFullPage() {
      return this.$store.state.app.scrollType !== 'normal'
    },
  },
  created() {
    this.set_view_pattern();
  },
  mounted() {
    this.init()
    this.globalKeydown(this.ctrl_z);
    this.globalKeydown(this.ctrl_y);
    this.globalKeydown(this.ctrl_s);
    this.getLangs();
    this.getSiteConfig()
  },
  watch:{
    '$store.state.app.web_language_wm': {
      handler: function(n) {
      if (n == 'en') {
        document.title = "Responsive website" 
      } else if (n == 'tc') {
        document.title = "響應式建站-marketingforce" 
      } else {
        document.title = "响应式建站-marketingforce" 
      }
      }, 
      immediate: true,
    }
  }
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue